import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-baefc420"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  title: "--"
}

import { computed } from 'vue'
import xss from 'xss'

const __default__ = { name: 'EditorTableText' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props
const valueComputed = computed(() => {
  return props.value ? xss(props.value) : ''
})

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (valueComputed.value)
    ? (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 0,
        placement: "topLeft"
      }, {
        title: _withCtx(() => [
          _createElementVNode("p", { innerHTML: valueComputed.value }, null, 8, _hoisted_1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("p", {
            innerHTML: valueComputed.value,
            class: "editorTxt"
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("p", _hoisted_3, "--"))
}
}

})